import { parseAbi, keccak256, toBytes, parseEther } from 'viem'
import { base } from 'wagmi/chains'
import OSEArcadeAbi from './abi/OSEArcade.json'

// OSE token on Base mainnet — every play burns tokens from the player's wallet.
// This is the address the deployed arcade's `token()` returns.
export const OSE_TOKEN_ADDRESS = '0x007fFAd3ef0E40380102d55F20784c11f0144B07'

// OSEArcade coin-slot contract (contracts/contracts/OSEArcade.sol), live on
// Base mainnet. VITE_ARCADE_ADDRESS overrides it for staging/testnet builds.
export const ARCADE_ADDRESS =
  import.meta.env.VITE_ARCADE_ADDRESS || '0xeA5201986b45DE705242b3dfFd8a56bF6d6d81fc'

export const ARCADE_CHAIN = base

// Fallback while costPerTurn() can't be read; the contract is the source of
// truth and currently returns this same value.
export const DEFAULT_COST = parseEther('10000')

// Generated from the Hardhat artifact by `npm run sync:abi`. Using the full
// compiled ABI (rather than a hand-written subset) means viem can decode the
// contract's custom errors — InsufficientBalance / InsufficientAllowance —
// into readable messages instead of raw revert data.
export const ARCADE_ABI = OSEArcadeAbi

export const ERC20_ABI = parseAbi([
  'function balanceOf(address account) view returns (uint256)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function approve(address spender, uint256 value) returns (bool)',
])

// Matches the bytes32 gameId the contract emits, e.g. keccak256("starswarm").
export function gameIdBytes32(gameId) {
  return keccak256(toBytes(gameId))
}
